export enum ShopSelectState {
  LOADING,
  READY,
  ERROR,
}

export enum ShopModalState {
  MINIMIZED,
  NORMAL,
  MAXIMIZED,
}
